module.exports = __webpack_public_path__ + "static/media/revision@3x.640b1db0.png";